export default __webpack_public_path__ + "locales/fi/DeleteDialog.json?hash=da389784f76ae067f12cdbcc18112a08";